﻿import { VoucherHolderType } from '@nkr/enums/voucher-holder-type';
import { AdpVoucherPrintStatus, Gender, Country, AdpVoucherHolderStatus, AboType } from '../enums/index';

export interface IAdpVoucherHolder {
    id: number,
    editKey: string,
    currentSelfRegistrationStep: number,
    donorId: number,
    type: VoucherHolderType,
    status: AdpVoucherHolderStatus,
    isAbnormalScreening: boolean,
    isAbnormalScreeningReviewed: boolean,
    requisitionNumber: string,
    createdDateTime: string,
    swabsOrderedDateTime: string, 
    lastScreeningOrderedDateTime: string, 
    lastScreeningResultsDateTime:string,
    pendingRedemptionDateTime: string, 
    redeemedDateTime: string, 
    retiredDateTime: string, 
    gender: Gender, 
    abo:AboType,
    ckdStatus: number,
    firstName: string,
    lastName: string,
    fullName: string,
    country: Country, 
    addressLine1: string, 
    addressLine2: string, 
    city: string, 
    stateProvince: string, 
    postalCode: string, 
    phoneNumberPrimary: string,
    phoneNumberSecondary: string, 
    emailPrimary: string, 
    emailSecondary: string, 
    birthDate: string, 
    adpInformedConsentFile: string,
    // consentFile: File,
    hlaSwabResultsFile: string, 
    hlaSwabRawResultsFile: string, 
    aboSwabRawResultsFile: string, 
    bloodType: string, 
    aboSwabPdfResultsFile: string,
    screeningRequisitionFile: string,
    screeningResultsFile: string, 
    certificatePrintedDateTime: string, 
    certificatePrintedUserId: number,
    certificateFirstCheckUserId: number,
    certificateSecondCheckUserId: number,
    kitReplacementCount: number, 
    willLikelyNeedKidneyTransplant: boolean,
    yearsBeforeKidneyTransplant: number,
    
    // recipientAlias: string,
    adpType: string,
    printStatus: AdpVoucherPrintStatus,
    registrationDate: string,
    donorRegistrationDate: string,

    donorAlias: string,
    age: number
}
